import React from 'react';
import {
  FaEnvelope,
  FaFacebook,
  FaInstagram,
  FaMapMarkerAlt,
} from 'react-icons/fa';

import './SocialLinksBar.css';

const SocialLinksBar = ({ className = '' }) => {
  return (
    <div className={`social-links-bar-container ${className}`}>
      <div className='social-links'>
        <a
          href='mailto:proevolutionwellness@gmail.com'
          aria-label='Email'
          className='email'
        >
          <FaEnvelope />
        </a>
        <a
          href='https://www.instagram.com/proevowellness/'
          target='_blank'
          rel='noopener noreferrer'
          aria-label='Instagram'
          className='ig'
        >
          <FaInstagram />
        </a>
        <a
          href='https://www.facebook.com/proevolutionwellnessinc/'
          target='_blank'
          rel='noopener noreferrer'
          aria-label='Facebook'
          className='fb'
        >
          <FaFacebook />
        </a>
        <a
          href='https://www.google.com/maps?ll=43.843501,-79.565679&z=16&t=m&hl=en&gl=CA&mapclient=embed&cid=13483159037294267179'
          target='_blank'
          rel='noopener noreferrer'
          aria-label='Map'
          className='map'
        >
          <FaMapMarkerAlt />
        </a>
      </div>
    </div>
  );
};

export default SocialLinksBar;
